/**
 * SC-1323 §4.3: maps PlayerShell's playerEvent stream onto today's podcast beacons, byte-identical
 * (pinned by tests/js/golden/podcastBeacons.golden.json). `video` is useVideoAnalytics() (POST
 * podcast.listen-video, 15 s heartbeat throttle, `vs`), `audio` is useAudioWorker() (POST
 * podcast.listen); either may be null. Preview sessions are swallowed inside both, as before.
 */
const VIDEO_ACTIONS = {
    play: "play",
    resume: "play",
    pause: "pause",
    ended: "finalized",
    seek: "scroll",
    mute: "mute",
    unmute: "unmute",
    buffering_start: "buffering_start",
    buffering_end: "buffering_end",
    quality_switch: "quality_switch",
    fullscreen_enter: "fullscreen_enter",
    fullscreen_exit: "fullscreen_exit",
    cta_click: "cta",
}

const AUDIO_ACTIONS = {
    play: "play",
    resume: "play",
    pause: "pause",
    ended: "finalized",
    seek: "scroll",
    mute: "mute",
    unmute: "unmute",
    cta_click: "cta",
}

function videoState(event) {
    const state = {}

    if ("fullscreen" in event) {
        state.fullscreen = event.fullscreen
    }
    if ("qualityHeight" in event) {
        state.qualityHeight = event.qualityHeight
    }
    if (event.viewport) {
        state.viewportPixels = event.viewport
    }
    if ("bufferingMs" in event) {
        state.bufferingMs = event.bufferingMs
    }
    if ("ctaId" in event) {
        state.ctaId = event.ctaId
    }

    return state
}

export function createPodcastAnalytics({ video = null, audio = null }) {
    function handleVideo(event) {
        if (!video) {
            return
        }

        // The heartbeat: useVideoAnalytics throttles it to one per 15 s of position.
        if (event.type === "time") {
            video.send({}, event.position)

            return
        }

        const action = VIDEO_ACTIONS[event.type]

        if (action) {
            video.send({ [action]: true }, event.position, videoState(event))
        }
    }

    function handleAudio(event) {
        if (!audio) {
            return
        }

        if (event.type === "beat") {
            audio.sendTrackingData({}, event.position)
            audio.previousSecond.value = event.currentTime

            return
        }

        const action = AUDIO_ACTIONS[event.type]

        if (!action) {
            return
        }

        if (action === "play") {
            audio.episodeDuration.value = Math.ceil(event.duration)
            audio.sendTrackingData({ play: true }, event.position)

            return
        }

        if (action === "cta") {
            audio.sendTrackingData({ cta: true }, event.position, event.ctaId ?? null)

            return
        }

        audio.sendTrackingData({ [action]: true }, event.position)
    }

    return {
        handle(event) {
            if (event.mode === "video") {
                handleVideo(event)
            } else if (event.mode === "audio") {
                handleAudio(event)
            }
        },
    }
}
